import React from 'react'

import Terms from '../components/Terms'

// import image

function Termspage() {
    return (
        <main className="max-w-[1150px] py-9 px-6 sm:px-9">
        <Terms />
        </main>
        )
}

export default Termspage